export default __webpack_public_path__ + "static/media/phone-rounded-svgrepo-com.da499586.svg";